import { email as validateEmail } from "capitalrx-utilities/lib/form-validation";

export const emailValidator = (value: string, translate: CallableFunction) => {
  const sanitizedValue = value?.trim?.();

  if (validateEmail(sanitizedValue) !== undefined) {
    return translate("FORM_FIELD_VALIDATION_ERRORS.youMustProvideValidEmail");
  }

  return undefined;
};
